import { render, staticRenderFns } from "./termsofuse-ar.vue?vue&type=template&id=4e58e4d6&scoped=true&"
import script from "./termsofuse-ar.vue?vue&type=script&lang=js&"
export * from "./termsofuse-ar.vue?vue&type=script&lang=js&"
import style0 from "./termsofuse-ar.vue?vue&type=style&index=0&id=4e58e4d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e58e4d6",
  null
  
)

export default component.exports